// 📁 src/constants/zIndexes.ts

export const Z_INDEX = {
  grid: 5000, // 🧱 Grille d’alignement
  block: 5001, // 🔲 Élément en drag/drop
  tooltip: 6000, // 💬 Tooltips, survols
  panels: 9999, // 🪟 Panneaux flottants
  modal: 10000, // 🔳 Modals, dialogues bloquants
  editorHandles: 8000,
  contextMenu: 9500,
  highlight: 5100,
};
